import { apiSlice } from "../../api/apiSlice";
import { setAllUsers } from "./companySlice";

export const companyApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createCompany: builder.mutation({
      query: (data) => ({
        url: "/api/company",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Company"],
    }),
    getAllCompanies: builder.query({
      query: (searchQuery = "") => ({
        url: `/api/company?query=${encodeURIComponent(String(searchQuery).trim())}`,
        method: "GET",
      }),
      serializeQueryArgs: ({ queryArgs }) => String(queryArgs ?? "").trim(),
      providesTags: ["Company"],
    }),
    deleteCompany: builder.mutation({
      query: (arg) => {
        const companyId = typeof arg === "string" ? arg : arg?.companyId;
        const note = typeof arg === "object" ? arg?.note || "" : "";
        return {
          url: `/api/company/${companyId}`,
          method: "DELETE",
          body: { note },
        };
      },
      invalidatesTags: ["Company", "Employee"],
    }),
    updateCompany: builder.mutation({
      query: ({ formData, companyId }) => ({
        url: `/api/company/${companyId}`,
        method: "PATCH",
        body: formData,
      }),
      invalidatesTags: ["Company"],
    }),
    getCompanyById: builder.query({
      query: (data) => {
        return {
          url: `/api/company/${data.companyId}`,
          method: "GET",
        }
      },
      providesTags: ["Company"],
    }),
    getCoursesByCompany: builder.query({
      query: (companyId) => ({
        url: `/api/lms/course/company/${companyId}`,
        method: "GET",
      }),
      providesTags: (result, error, companyId) => [
        "Company",
        { type: "Company", id: companyId },
      ],
    }),
    getUsersByCompany: builder.query({
      query: (data) => {
        const isActiveParam =
          data?.isActive === true || data?.isActive === false
            ? `&isActive=${data.isActive}`
            : "";
        return {
          url: `/api/user/company/${data.companyId}/?limit=${data?.limit}&page=${data?.page}&query=${encodeURIComponent(data.query || "")}${isActiveParam}`,
          method: "GET",
        };
      },
    }),
    getCompanyAdmin: builder.query({
      query: (companyId) => ({
        url: `/api/user/company/companyAdmin/${companyId}`,
        method: "GET",
      }),
    }),
    getAllUsersCompany: builder.query({
      query: (companyId) => {
        const params = companyId ? `?companyId=${encodeURIComponent(companyId)}` : "";
        return {
          url: `/api/company/admin-candidates${params}`,
          method: "GET",
        };
      },
    }),
    getAllUsers: builder.query({
      query: (data) => {
        const isActiveParam =
          data?.isActive === true || data?.isActive === false
            ? `&isActive=${data.isActive}`
            : "";
        return {
          url: `/api/user?page=${data?.page}&limit=${data?.limit}&sort_by=${data?.sortBy || "createdAt"}&type=${
            data?.type || "desc"
          }&query=${encodeURIComponent(data.query)}${isActiveParam}`,
          method: "GET",
        };
      },
      providesTags: ["Employee"],
      async onQueryStarted(arg, { dispatch, queryFulfilled, q }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setAllUsers(data));
          // Set redux login state.
        } catch (error) {
          console.error("error", error);
        }
      },
    }),
  }),
});

export const {
  useCreateCompanyMutation,
  useGetAllUsersQuery,
  useGetAllUsersCompanyQuery,
  useGetAllCompaniesQuery,
  useGetCoursesByCompanyQuery,
  useGetCompanyAdminQuery,
  useGetUsersByCompanyQuery,
  useDeleteCompanyMutation,
  useGetCompanyByIdQuery,
  useUpdateCompanyMutation,
} = companyApiSlice;

